import i18n from '@/i18n';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { createToastContent } from '@/utilities/toast';
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { ErrorCodes, FormSteps, Screen } from '../../shared/types';
import { createAppUser, validateAppUser } from '../data';
const toast = useToast();
const { t } = i18n.global;
const currentScreen = ref(Screen.FORM);
const currentFormView = ref(FormSteps.VALIDATE);
const userData = ref(null);
const showSuccessModal = ref(false);
const toastOptions = {
    icon: false,
    toastClassName: 'login-toaster',
    timeout: 6000,
};
export function useAppAuth() {
    const loading = ref(false);
    async function validateLogin(pin, token) {
        loading.value = true;
        const result = await validateAppUser(pin, token);
        if (!result.success) {
            const content = createToastContent(t('login360.toast.notFound.title'), t('login360.toast.notFound.message'));
            toast.error(content, toastOptions);
            loading.value = false;
            return;
        }
        userData.value = result.data;
        if (userData.value.imported) {
            const content = createToastContent(t('login360.toast.alreadyRegistered.title'), t('login360.toast.alreadyRegistered.message'));
            toast.error(content, toastOptions);
            loading.value = false;
            return;
        }
        changeFormView(FormSteps.REGISTER);
        loading.value = false;
    }
    async function createUser({ email, nickname }) {
        loading.value = true;
        const result = await createAppUser({
            email,
            nickname,
            id: String(userData.value.id),
            accessToken: userData.value.accessToken,
        });
        if (!result.success) {
            const error = result.error;
            if (error === ErrorCodes.USER_LOGIN_ALREADY_EXISTS || error === ErrorCodes.DUPLICATED_SELLER_ENROLMENT) {
                const content = createToastContent(t('login360.toast.userExists.title'), t('login360.toast.userExists.message'));
                toast.error(content, toastOptions);
                useMixpanelConfig('view_migration360_error_registered');
            }
            useMixpanelConfig('view_migration360_error_notidentified');
            loading.value = false;
            return;
        }
        showSuccessModal.value = true;
        loading.value = false;
        useMixpanelConfig('view_migration360_seller_success');
    }
    function changeFormView(screen) {
        currentFormView.value = screen;
    }
    function changeCurrentScreen(screen) {
        currentScreen.value = screen;
    }
    function goBack() {
        changeFormView(FormSteps.VALIDATE);
    }
    return {
        loading,
        userData,
        currentScreen,
        currentFormView,
        showSuccessModal,
        changeCurrentScreen,
        validateLogin,
        createUser,
        goBack,
    };
}
